export const SERVICE_FLOW_QUERY_KEYS = Object.freeze({
  CONFIGURATION_GUID: 'configurationGuid',
  SERIAL_NO: 'serialNo',
});
